import { IWedding_Website_Section_PhotosField } from '@bridebook/models/source/models/Weddings.types';
import { MainPalette } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/palette-config';
import type { CSSProperties } from 'react';
import { SECTION_NAMES } from './constants';

export enum Palettes {
  Bridebook = 'bridebook',
  Foliage = 'foliage',
  Roses = 'roses',
  Whimsical = 'whimsical',
}

export enum Fonts {
  Playfair = 'playfair',
  OpenSans = 'opensans',
  OrelegaOne = 'orelegaone',
  Montserrat = 'montserrat',
  Aboreto = 'aboreto',
  Figtree = 'figtree',
  MeowScript = 'meowscript',
  EBGaramond = 'ebgaramond',
}

export enum FontPairs {
  Bridebook = 'bridebook',
  Foliage = 'foliage',
  Roses = 'roses',
  Whimsical = 'whimsical',
}

export type TWebsiteThemeId = `${Palettes}-${FontPairs}`;

export type TWebsiteTheme = {
  palette: Palettes;
  font: FontPairs;
};

export type TFontsPair = {
  primary: Fonts;
  secondary: Fonts;
};

export type TColorPaletteHighlights = [primary: string, secondary: string, tertiary: string];

export interface IFontStyle {
  fontFamily: Required<CSSProperties>['fontFamily'];
  fontWeight: Required<CSSProperties>['fontWeight'];
  fontUrl: string;
  lineHeight?: CSSProperties['fontWeight'];
}

// onboarding - store types
interface IWeddingWebsiteOnboardingMetaProperties {
  open: boolean;
  activeStep: number;
}

// extra settings for form values, such as marking date/venue as unknown
export interface IWeddingWebsiteOnboardingFormConfig {
  weddingDateNotConfirmed: boolean;
  venueNotConfirmed: boolean;
}

export interface IWeddingWebsiteOnboardingState extends IWeddingWebsiteOnboardingMetaProperties {
  formConfig: IWeddingWebsiteOnboardingFormConfig;
}

export interface INamesFormFields {
  name: string;
  partnerName: string;
}
export interface IDateFormFields {
  weddingDate?: string;
}
export interface IPinFormFields {
  pin: string;
}

export interface IOnboardingFormFields {
  name: string;
  partnerName: string;
  weddingDate?: string;
  venueId?: string;
  palette?: MainPalette;
  photo?: IWedding_Website_Section_PhotosField['data'][number] | null | 'STATE_UPLOADING';
  weddingDateUndecided: boolean;
  venueIdUndecided: boolean;
}

export interface IWeddingWebsiteDesignTabsState {
  isThemesOpen: boolean;
  isCustomiseOpen: boolean;
}

export interface IVenueDateFormFields {
  weddingDate?: string;
  venueId?: string;
}

export type TSectionName = (typeof SECTION_NAMES)[keyof typeof SECTION_NAMES];
